<template>
  <div class="mb-16">
    <div v-if="isDefault" class="btns">
      <h2>Default</h2>
    </div>
    <div v-else>
      <div class="pb-2">
        <button class="btn btn-primary w-full" @click="resetDefault">
          YES
        </button>
      </div>
      <button class="border-2 btn btn-secondary w-full" @click="closeModal">
        NO
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Confirm-Reset-Dialog",
  props: {
    templateId: String,
  },

  data() {
    return {
      templateToDefault: false,
      isDefault: false,
    };
  },

  async mounted() {},

  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    async resetDefault() {
      const { business } = await this.$store.getters["account/me"];
      try {
        await this.$store.dispatch("accreditation/resetDefault", {
          businessId: business._id,
        });
        this.$emit("closeModal");
        this.$emit("refetch");
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style scoped></style>
